import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const forgeGlobalRoute: InvariantJiraRoute = {
	name: 'forge-spa-global',
	path: '/jira/apps/:appId/:envId/:route?',
};
